import {JSX} from "react";

import {Typography} from "@/shared/ui/data-display/typography";
import {ResponsiveSize} from "@/shared/ui/data-display/typography/typography";

interface HeroDescriptionProps {
    children?: string;

    size?: ResponsiveSize;
}

export function HeroDescription({children, size = {desktop: 20, mobile: 16}}: HeroDescriptionProps): JSX.Element {
    return <Typography className="hero__description" as="p" size={size} weight={400} lineHeight={150} color="white" innerHTML={children} />;
}
